const deviceInformationMonitor = require('../monitors/device-info');
const connectionInformationMonitor = require('../monitors/connection-info');
const navigationTimingMonitor = require('../monitors/navigation-timing');
const perfumeMonitor = require('../monitors/perfume');
const browserInformationMonitor = require('../monitors/browser-info');
const documentContentMonitor = require('../monitors/document-content');
const mlSessionInformationMonitor = require('../monitors/mlsession-info');
const webVitalsTrigger = require('../triggers/web-vitals');
const { prepareConfiguration } = require('../config');

const {
  supportsPerformanceApi,
  supportsBeaconOrFetch,
} = require('../support');
const { onBFCacheRestore } = require('../utils/bfcache');
const { clearAllMetrics } = require('../collector');

/**
 * The initializeMonitors() function is used to initialize all monitoring processes except for
 * the perfumeMonitor(), which is handled separately. All the other monitoring functions
 * are called inside initializeMonitors to ensure they are set up when the page is loaded or
 * restored from the BFCache. perfumeMonitor() is called only once before initializeMonitors() to
 * avoid redundant initialization, as it's a more specific process that doesn’t need to be repeated.
*/
const initializeMonitors = () => {
  deviceInformationMonitor();
  connectionInformationMonitor();
  browserInformationMonitor();
  navigationTimingMonitor();
  documentContentMonitor();
  mlSessionInformationMonitor();
  webVitalsTrigger();
};

const start = (args, initiative) => {
  const settings = prepareConfiguration(args);
  if (!settings) {
    return;
  }

  onBFCacheRestore(() => {
    clearAllMetrics(initiative);
    // init monitors on bfcache restore
    initializeMonitors();
  });

  try {
    if (supportsPerformanceApi() && supportsBeaconOrFetch()) {
      perfumeMonitor(settings, initiative);
      // init monitors on page load
      initializeMonitors();
    }
    // eslint-disable-next-line no-empty
  } catch (e) {}
};

module.exports = {
  start,
};
